import * as S from './EventDescription.styles'
import { Heading, Paragraph, Button } from 'applaus-ui-kit'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addDescription, stepBack } from '../../../../redux/Events/actions'
import { setAlertModalAction } from '../../../../redux/AlertModal/actions'
import { ReduxState } from '../../../../redux/rootReducer'
import { RichText } from '../../../../components/RichText/RichText'
import { clearLoading } from '../../../../redux/Loading/actions'

export const EventDescription = () => {
  const dispatch = useDispatch()
  const { manageEvent } = useSelector((state: ReduxState) => state.EventReducer)
  const [descripton, setDescripton] = useState('')

  const onSubmit = () => {
    const characterCount = descripton.length
    if (characterCount > 0 && characterCount < 3) {
      dispatch(
        setAlertModalAction({
          title: 'Descrição deve ter pelo menos 3 caracteres',
          variant: 'error',
          open: true,
          buttonText: 'Fechar'
        })
      )
    } else if (characterCount > 0 && characterCount > 255) {
      dispatch(
        setAlertModalAction({
          title: 'Descrição deve ter no máximo 255 caracteres',
          variant: 'error',
          open: true,
          buttonText: 'Fechar'
        })
      )
    } else {
      dispatch(addDescription(descripton))
    }
  }

  const onLoadRichText = () => {
    dispatch(clearLoading())
  }

  return (
    <S.Container>
      <S.Wrapper>
        <S.TitleBox>
          <S.BackIcon onClick={() => dispatch(stepBack())} />
          <Heading variant="h3">Descrição do evento</Heading>
        </S.TitleBox>
        <Paragraph variant="large">
          Chegou o momento de falar sobre seu evento. Conte todos os <br />
          detalhes, como a programação, regras e classificação.
        </Paragraph>

        <Paragraph variant="large">Máximo de caracteres: 250</Paragraph>

        <RichText
          data={manageEvent?.description ?? ''}
          onReady={onLoadRichText}
          onChange={(value) => setDescripton(value)}
        />
        <Button
          onClick={onSubmit}
          variant="contained"
          fullWidth={false}
          type="button"
          size="medium"
          color="primary">
          Continuar
        </Button>
      </S.Wrapper>
    </S.Container>
  )
}
